import { useCallback } from 'react';

export const useTrackElementVisibilityInViewPort = () => {
  // Function to track when an element first appears in the viewport
  const trackElementVisibility = useCallback((
    elementToTracks: Element[],
    callback: (element: Element | null) => void,
  ) => {
    const observers: IntersectionObserver[] = [];

    elementToTracks.forEach((elementToTrack) => {
      if (!elementToTrack) return; // Check if element exists

      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          // The element is in the viewport
          observer.disconnect(); // Disconnect the observer to stop tracking
          callback(elementToTrack);
        }
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 1.0,
      });

      observer.observe(elementToTrack);
      observers.push(observer);
    });

    // Return the observers to be able to disconnect them
    return observers;
  }, []);
  return trackElementVisibility;
};
